import { useQuery } from '@tanstack/react-query';

import { Hub, type HubTab } from '../components/Hub';
import { PhoneConfirmations } from '../ops/PhoneConfirmations';
import { UnassignedAppointments } from '../ops/UnassignedAppointments';
import { useMe } from '../auth/context';
import { useFieldOnly, useIsFieldSales, useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { CalendarPage } from './CalendarPage';
import { FieldSalesPage } from './FieldSalesPage';

// Termine: eigene Termine mit Tagesroute (Makler), Team-Kalender und Termine ohne Makler (Büro).
export function AppointmentsHub() {
  const { project, can } = useProject();
  const papi = useProjectApi();
  const fieldSales = useIsFieldSales();
  const fieldOnly = useFieldOnly();
  const me = useMe();
  // Termin-Organisation (Terminierer, Support, Leitung).
  const office = can('ticket.manage') || can('appointment.reschedule') || can('appointment.override_assignment');
  // Telefonische Terminbestätigungen: für alle, die telefonieren (Terminplanung; das Büro hat sie zusätzlich im Posteingang).
  const confirming = can('call.start');
  const dash = useQuery({ queryKey: projectKeys.dashboard(project.id), queryFn: ({ signal }) => papi.dashboard(signal), enabled: office });
  const confirmations = useQuery({
    queryKey: projectKeys.phoneConfirmations(project.id, 'open'),
    queryFn: ({ signal }) => papi.phoneConfirmations('open', signal),
    enabled: confirming,
    refetchInterval: 60_000,
  });
  const tabs: HubTab[] = [];
  if (fieldSales) tabs.push({ key: 'meine', label: fieldOnly ? 'Tag mit Route' : 'Meine Termine', render: () => <FieldSalesPage embedded /> });
  // Makler: Woche und Monat nur mit den eigenen Terminen (B-28).
  if (can('calendar.read'))
    tabs.push({
      key: 'kalender',
      label: fieldOnly ? 'Woche & Monat' : 'Kalender',
      render: () => <CalendarPage embedded ownUserId={fieldOnly ? me.user.id : undefined} />,
    });
  if (confirming)
    tabs.push({
      key: 'bestaetigungen',
      label: 'Terminbestätigungen',
      count: confirmations.data?.items.length,
      tone: confirmations.data?.items.some((i) => i.overdue) ? 'error' : 'warn',
      render: () => <PhoneConfirmations />,
    });
  if (can('calendar.read') && office)
    tabs.push({
      key: 'ohne-makler',
      label: 'Ohne Makler',
      count: dash.data?.support?.unassigned_appointments,
      tone: 'warn',
      render: () => <UnassignedAppointments />,
    });
  const description = office
    ? 'Termine aller Makler – Kalender, telefonische Terminbestätigungen und Termine ohne Makler.'
    : 'Ihre Termine – der Tag mit Route sowie Woche und Monat im Überblick.';
  return <Hub title="Termine" description={description} tabs={tabs} />;
}
